import './styles.sass';

import React from 'react';

import Summary from './Summary';
import JournalsAnalysisTable from './JournalsAnalysisTable';
import PageTitle from 'components/Explorer/PageTitle';

const Journals = () => (
  <div className="Explorer-Journals">
    <PageTitle metaTitle={I18n.t('Explorer.TabBar.journals')} />
    <Summary />
    <JournalsAnalysisTable />
  </div>
);

export default Journals;
